import { render, staticRenderFns } from "./checkLogin2.vue?vue&type=template&id=265f889a&"
import script from "./checkLogin2.vue?vue&type=script&lang=js&"
export * from "./checkLogin2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports